// src/pages/Landing.jsx
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { useLanguage } from "../i18n/LanguageContext";
import "./Landing.css";



import logoMark from "../assets/landing/logo_512.png";
import heroBg from "../assets/landing/hero-bg.jpg";
import mockDashboard from "../assets/landing/general.jpg";
import letraIm from "../assets/landing/lyrics-shot.png";
import cancionIm from "../assets/landing/cancion01.jpg";
import precioFondo from "../assets/landing/fondo_precio.jpg";

import LanguageSwitcher from "../components/LanguageSwitcher";
import LanguageDropdown from "../components/LanguageDropdown";




// (Opcional) si ya no los usarás, puedes borrarlos
// import stepIlustration from "../assets/landing/how-step-illustrations.jpg";
// import trustBadges from "../assets/landing/trust-badges.jpg";

 function FAQItem({ q, a, isOpen, onToggle }) {
    return (
      <div className={`lp-faq-item ${isOpen ? "open" : ""}`}>
        <button type="button" className="lp-faq-q" onClick={onToggle}>
          <span>{q}</span>
          <span className="lp-faq-icon">{isOpen ? "−" : "+"}</span>
        </button>

        <div className="lp-faq-a" aria-hidden={!isOpen}>
          <div className="lp-faq-a-inner">{a}</div>
        </div>
      </div>
    );
  }


export default function Landing() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  
  // Dentro de tu componente Landing:
  const [openIdx, setOpenIdx] = useState(0);

  const faqs = [
    { q: t("landing.faq.q1"), a: t("landing.faq.a1") },
    { q: t("landing.faq.q2"), a: t("landing.faq.a2") },
    { q: t("landing.faq.q3"), a: t("landing.faq.a3") },
    { q: t("landing.faq.q4"), a: t("landing.faq.a4") },
    { q: t("landing.faq.q5"), a: t("landing.faq.a5") },
    { q: t("landing.faq.q6"), a: t("landing.faq.a6") },
    { q: t("landing.faq.q7"), a: t("landing.faq.a7") },
    { q: t("landing.faq.q8"), a: t("landing.faq.a8") }
  ];

 
  const isLogged = useMemo(() => !!auth.currentUser, []);

  const goToApp = () => navigate(isLogged ? "/app" : "/login");
  const goToForm = () => navigate("/create"); // ✅ wizard público
  const goToDirecto = () => navigate("/formulario"); // ✅ wizard público

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

 


  return (
    <div className="lp">
      {/* Top bar */}
      <header className="lp-topbar">
        <div className="lp-container lp-topbar-inner">
          <div className="lp-brand">
            <img className="lp-mark-img" src={logoMark} alt={`${t("app.name")} logo`} />
            <span className="lp-brand-name">{t("app.name")}</span>
          </div>

          <LanguageDropdown size="md" showLabel align="left" />       


          <div className="lp-topbar-actions">
            <button className="lp-top-cta" onClick={goToApp}>
              {t("landing.cta.button")}
            </button>

            <button className="lp-top-cta" onClick={goToDirecto}>
              {t("landing.formCta")}
            </button>

            
          </div>
        </div>
      </header>

     
 
      {/* 1) Sección principal (Hero) */}
      <section className="lp-hero" id="top">
        <div
          className="lp-hero-bg"
          aria-hidden
          style={{ backgroundImage: `url(${heroBg})` }}
        />
        {/* Mini menú: accesos rápidos */}
        <section className="lp-miniNav" id="mini-nav">
          <div className="lp-container">
            <div className="lp-miniNav-bar">
              <button type="button" className="lp-miniNav-item" onClick={() => scrollToId("crear-letra")}>
                <span className="lp-miniNav-ic">✍️</span>
                <span className="lp-miniNav-tx">{t("landing.nav.lyrics")}</span>
              </button>

              <button type="button" className="lp-miniNav-item" onClick={() => scrollToId("crear-cancion")}>
                <span className="lp-miniNav-ic">🎵</span>
                <span className="lp-miniNav-tx">{t("landing.nav.song")}</span>
              </button>

              <button type="button" className="lp-miniNav-item" onClick={() => scrollToId("precios")}>
                <span className="lp-miniNav-ic">💳</span>
                <span className="lp-miniNav-tx">{t("landing.nav.pricing")}</span>
              </button>

              <button type="button" className="lp-miniNav-item" onClick={() => scrollToId("faq")}>
                <span className="lp-miniNav-ic">❓</span>
                <span className="lp-miniNav-tx">{t("landing.nav.faq")}</span>
              </button>
            </div>
          </div>
        </section>
      

        <div className="lp-container lp-hero-inner">
          <div className="lp-hero-left">
            <h1 className="lp-h1">{t("landing.hero.title")}</h1>

            <p className="lp-sub">
             {t("landing.hero.subtitle")}
            </p>

            <div className="lp-hero-actions">
              <button className="lp-btn lp-btn-primary" onClick={goToDirecto}>
                 {t("landing.hero.ctaPrimary")}            
             </button>

              <button className="lp-btn lp-btn-ghost" onClick={() => scrollToId("how-it-works")}>
                {t("landing.hero.ctaSecondary")}  
              </button>

               <button className="lp-btn lp-btn-primary" onClick={goToApp}>
                 {t("landing.cta.button")}            
              </button>
            </div>
          </div>


          <div className="lp-hero-right">
            <div className="lp-mock">
              <img className="lp-mock-img" src={mockDashboard} alt="Dashboard preview" />             
            </div>
          </div>
        </div>

         <div className="lh-cards">
            <div className="lh-card">
              <h3>{t("landing.hero.cards.demo.title")}  </h3>
              <p>
                {t("landing.hero.cards.demo.desc")}  
              </p>
            </div>

            <div className="lh-card">
              <h3>{t("landing.hero.cards.library.title")}  </h3>
              <p>{t("landing.hero.cards.library.desc")}  
              </p>
            </div>

            <div className="lh-card">
              <h3>{t("landing.hero.cards.payment.title")}  </h3>
              <p>{t("landing.hero.cards.payment.desc")}  
              </p>
            </div>
          </div>

      </section>



      {/* 2) Sección: Creando letra */}
      <section className="lp-section lp-split" id="crear-letra">
        <div className="lp-container lp-split-inner">
          {/* Izquierda */}
          <div className="lp-split-left">
            

            <h2 className="lp-h2">✍️ {t("landing.lyrics.title")}</h2>

            <p className="lp-sub-soft">
              {t("landing.lyrics.subtitle")}
            </p>

            <ul className="lp-bullets">
              <li>✅ {t("landing.lyrics.bullet1")}</li>
              <li>✅ {t("landing.lyrics.bullet2")}</li>
              <li>✅ {t("landing.lyrics.bullet3")}</li>
            </ul>

            <div className="lp-split-actions">
              <button className="lp-btn lp-btn-primary" onClick={goToDirecto}>
                {t("landing.lyrics.cta")}
              </button>

              <a
                className="lp-link"
                href="https://www.youtube.com"   // <-- aquí luego pones tu video real
                target="_blank"
                rel="noreferrer"
              >
                ▶ {t("landing.lyrics.video")}
              </a>
            </div>
          </div>


          <div className="lp-hero-right">
            <div className="lp-mock">
              <img className="lp-mock-img" src={letraIm} alt="Dashboard preview" />             
            </div>
          </div>

        </div>
      </section>


      {/* 3) Sección: Creando mi canción */}
      <section className="lp-section lp-split lp-split-reverse" id="crear-cancion">
        <div className="lp-container lp-split-inner">
          {/* Izquierda: imagen */}
          <div className="lp-split-media">
            <div className="lp-mock lp-mock--lg">
              <img className="lp-mock-img" src={cancionIm} alt="Crear canción - captura" />
            </div>
          </div>

          {/* Derecha: texto */}
          <div className="lp-split-content">
            <h2 className="lp-h2">🎵 {t("landing.song.title")}</h2>

            <p className="lp-sub-soft">
              {t("landing.song.subtitle")}
            </p>

            <ul className="lp-bullets">
              <li>✅ {t("landing.song.bullet1")}</li>
              <li>✅ {t("landing.song.bullet2")}</li>
              <li>✅ {t("landing.song.bullet3")}</li>
            </ul>

            <div className="lp-split-actions">
              <button className="lp-btn lp-btn-primary" onClick={goToDirecto}>
                {t("landing.song.cta")}
              </button>

              <a
                className="lp-link"
                href="https://www.youtube.com"
                target="_blank"
                rel="noreferrer"
              >
                ▶ {t("landing.song.video")}
              </a>
            </div>
          </div>
        </div>
      </section>

     {/* 4) Sección: Inicio rápido */}
      <section className="lp-section lp-quick" id="inicio-rapido">
        <div className="lp-container">
          <div className="lp-quick-head">
            <h2 className="lp-h2">🚀 {t("landing.quick.title")}</h2>
            <p className="lp-sub-soft lp-quick-sub">
              {t("landing.quick.subtitle")}
            </p>
          </div>

          <div className="lp-quick-flow">
            {/* Paso 1 */}
            <div className="lp-quick-step">
              <div className="lp-quick-icon">💡</div>
              <div className="lp-quick-text">
                <div className="lp-quick-title">{t("landing.quick.step1.title")}</div>
                <div className="lp-quick-desc">{t("landing.quick.step1.desc")}</div>
              </div>
            </div>

            <div className="lp-quick-arrow">→</div>

            {/* Paso 2 */}
            <div className="lp-quick-step">
              <div className="lp-quick-icon">📝</div>
              <div className="lp-quick-text">
                <div className="lp-quick-title">{t("landing.quick.step2.title")}</div>
                <div className="lp-quick-desc">{t("landing.quick.step2.desc")}</div>
              </div>
            </div>

            <div className="lp-quick-arrow">→</div>

            {/* Paso 3 */}
            <div className="lp-quick-step">
              <div className="lp-quick-icon">🎧</div>
              <div className="lp-quick-text">
                <div className="lp-quick-title">{t("landing.quick.step3.title")}</div>
                <div className="lp-quick-desc">{t("landing.quick.step3.desc")}</div>
              </div>
            </div>
          </div>

          <div className="lp-quick-cta">
            <button className="lp-btn lp-btn-primary" onClick={goToDirecto}>
              {t("landing.quick.cta")}
            </button>
          </div>
        </div>
      </section>


      {/* Sección: Precios */}
     <section className="lp-section lp-pricing lp-pricing-bg" id="precios"  style={{ "--pricing-bg": `url(${precioFondo})` }}>
        <div className="lp-container">
          <div className="lp-center">
            <h2 className="lp-h2">💳 {t("landing.pricing.title")}</h2>
            <p className="lp-sub-soft lp-pricing-sub">
              {t("landing.pricing.subtitle")}
            </p>
          </div>

          <div className="lp-pricing-wrap">
            <div className="lp-price-card">
              <div className="lp-price-top">
                <div className="lp-price-title">{t("landing.pricing.plan.title")}</div>

                <div className="lp-price-amount">
                  <span className="lp-price-number">{t("landing.pricing.plan.price")}</span>
                  <span className="lp-price-per">{t("landing.pricing.plan.per")}</span>
                </div>
              </div>

              <ul className="lp-price-list">
                <li>✅ {t("landing.pricing.b1")}</li>
                <li>✅ {t("landing.pricing.b2")}</li>
                <li>✅ {t("landing.pricing.b3")}</li>
                <li>✅ {t("landing.pricing.b4")}</li>
              </ul>

              <div className="lp-price-note">
                {t("landing.pricing.note")}
              </div>

             <div className="lp-price-actions lp-price-actions-2">
                <button className="lp-btn lp-btn-primary" onClick={goToDirecto}>
                  {t("landing.pricing.cta")}
                </button>

                <button className="lp-btn lp-btn-primary" onClick={goToApp}>
                  {t("landing.pricing.loginCta")}
                </button>
              </div>

            </div>
          </div>
        </div>
      </section>



      {/* 5) Sección: Cómo funciona */}
      <section className="lp-section" id="how-it-works">
        <div className="lp-container">
          <h2 className="lp-h2">{t("landing.section.how.title")}</h2>

          <div className="lp-steps">
            <div className="lp-step">
              <div className="lp-step-num">1</div>
              <div>
                <div className="lp-step-title">{t("landing.section.how.step1.title")}</div>
                <div className="lp-step-desc">{t("landing.section.how.step1.desc")}</div>
              </div>
            </div>

            <div className="lp-step">
              <div className="lp-step-num">2</div>
              <div>
                <div className="lp-step-title">{t("landing.section.how.step2.title")}</div>
                <div className="lp-step-desc">{t("landing.section.how.step2.desc")}</div>
              </div>
            </div>

            <div className="lp-step">
              <div className="lp-step-num">3</div>
              <div>
                <div className="lp-step-title">{t("landing.section.how.step3.title")}</div>
                <div className="lp-step-desc">{t("landing.section.how.step3.desc")}</div>
              </div>
            </div>

            <div className="lp-step">
              <div className="lp-step-num">4</div>
              <div>
                <div className="lp-step-title">{t("landing.section.how.step4.title")}</div>
                <div className="lp-step-desc">{t("landing.section.how.step4.desc")}</div>
              </div>
            </div>
          </div>
         
        </div>
      </section>


      {/* Sección: FAQ */}
      <section className="lp-section lp-faq" id="faq">
        <div className="lp-container">
          <div className="lp-center">
            <h2 className="lp-h2">❓ {t("landing.faq.title")}</h2>
            <p className="lp-sub-soft lp-faq-sub">{t("landing.faq.subtitle")}</p>
          </div>

          <div className="lp-faq-list">
            {faqs.map((item, idx) => (
              <FAQItem
                key={idx}
                q={item.q}
                a={item.a}
                isOpen={openIdx === idx}
                onToggle={() => setOpenIdx(openIdx === idx ? -1 : idx)}
              />
            ))}
          </div>
        </div>
      </section>

     
     
      {/* Footer */}
      <footer className="lp-footer">
        <div className="lp-container lp-footer-inner">
          <div className="lp-footer-left">
            <div className="lp-brand">
              <img className="lp-mark-img" src={logoMark} alt={`${t("app.name")} logo`} />
              <span className="lp-brand-name">{t("app.name")}</span>
            </div>
            <div className="lp-footer-muted">
              © {new Date().getFullYear()} · {t("landing.footer.rights")}
            </div>
          </div>

          <div className="lp-footer-right">
            <span className="lp-footer-muted">{t("landing.footer.contact")}:</span>
            <a className="lp-footer-link" href="mailto:musicaalacartaapp@gmail.com">
              musicaalacartaapp@gmail.com
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
